import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Button from "../../../Component/Button";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/userActions";
import { Container, Row, Col, Form } from "react-bootstrap";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";
import * as settingActions from "../../../actions/settingActions";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import queryString from "query-string";
import PopupModalWithOk from "../../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const Index = (props) => {

  const { superUserParams, setting, actions } = props;
  const { register, handleSubmit, watch, formState: { errors } } = useForm({ defaultValues: superUserParams });
  const [popupMessage, setPopupMessage] = useState("");

  const [showPopup, setShowPopup] = useState(false);
  const [redirectToLogin, setRedirectToLogin] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const result = await actions.getSettingData();
      // Only show popup if you want the user to know something changed
      console.log("", result)
    };
    fetchData();
  }, [actions]);

  const location = useLocation();
  const queryStringParsed = queryString.parse(location.search);
  const forgotString = queryStringParsed["validating_string"];
  const history = useNavigate();
  const onSubmit = (data) => {
    data.forgot_password_validate_string = forgotString;
    agent
      .post(API.RESETPASSWORD, data)
      .then((res) => {
        setPopupMessage(res.data.message);
        setShowPopup(true);
        setRedirectToLogin(true);
        // history("/login");

      })
      .catch((err) => {
        setPopupMessage(err.message);
        setShowPopup(true);
        setRedirectToLogin(false);
      });
  };
  const newPassword = watch('password');
  const conNewPassword = watch('password_confirmation')
  const conditionCheck = newPassword != conNewPassword && !errors.password_confirmation

  const [showPassword, setShowPassword] = useState(true);

  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    setShowPassword((prevState) => !prevState);
  };

  const [showPassword1, setShowPassword1] = useState(true);

  const togglePasswordVisibility1 = (e) => {
    e.preventDefault();
    setShowPassword1((prevState) => !prevState);
  };

  return (
    <>
      <section className="loginouter ">
        <Container>
          <Row className="align-items-center ">
            <Col md={12}>
              <div className="logininnerouter resetouter">
                <div>
                  <div className="loginlogo text-center mb-5">
                    <Link to="/" className="logo m-0">
                      {setting?.logo_path && <img src={setting?.logo_path} alt="logo" style={{ maxWidth: '200px', maxHeight: '59px' }} />}
                    </Link>
                  </div>
                  <div className="loginform change_reset_password">
                    <h1>Reset Password</h1>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      <Row>
                        <Col md={12} sm={12}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="password">Password*</label>
                            <div style={{ position: 'relative' }}>
                              <Form.Control
                                type={showPassword ? "password" : "text"}
                                style={{ paddingRight: '43px' }}
                                className={'form-control'}
                                name="password"
                                aria-invalid={errors?.name ? "true" : "false"}
                                {...register("password", {
                                  required: true,
                                  minLength: 6,
                                  pattern: {
                                    value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!()@$%^&*-]).{6,}$/i,
                                  },
                                })}
                              />

                              <button
                                type="button"
                                className="password-toggle-icon"
                                onClick={togglePasswordVisibility}
                                style={{ all: "unset", cursor: "pointer", position: "absolute", right: "21px", top: "52%", transform: "translateY(-50%)" }}
                                type="button"
                              >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </button>
                            </div>
                            {errors?.password &&
                              errors?.password?.type === "required" && (
                                <label style={{ color: 'red', fontSize: '15px' }} htmlFor="password">
                                  Please enter your password
                                </label>
                              )}
                            {errors?.password &&
                              errors?.password?.type === "minLength" && (
                                <label style={{ color: 'red', fontSize: '15px' }} htmlFor="password">
                                  Your password should contain at least 6
                                  characters
                                </label>
                              )}
                            {errors?.password &&
                              errors?.password?.type === "pattern" && (
                                <label style={{ color: 'red', fontSize: '15px' }} htmlFor="password">
                                  Password must have a minimum of 6 characters. It must be a combination of numerals, alphabet and special characters. Special characters don't include comma, underscores, full stop etc.
                                </label>
                              )}
                          </div>
                        </Col>

                        <Col md={12} sm={12}>
                          <div className="form-group ">
                            <label className="form-label" htmlFor="password_confirmation">Confirm Password*</label>
                            <div style={{ position: 'relative' }}>
                              <Form.Control

                                type={showPassword1 ? "password" : "text"}
                                style={{ paddingRight: '43px' }}
                                className={'form-control'}
                                name="password_confirmation"
                                aria-invalid={
                                  errors?.password_confirmation ? "true" : "false"
                                }
                                {...register("password_confirmation", {
                                  required: true,
                                  minLength: 6,
                                  pattern: {
                                    value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!()@$%^&*-]).{6,}$/i,
                                  },
                                })}
                              />

                              <button
                                type="button"
                                className="password-toggle-icon"
                                onClick={togglePasswordVisibility1}
                                style={{ all: "unset", cursor: "pointer", position: "absolute", right: "21px", top: "52%", transform: "translateY(-50%)" }}
                                type="button"
                              >
                                {showPassword1 ? <FaEyeSlash /> : <FaEye />}
                              </button>

                            </div>


                            {errors?.password_confirmation &&
                              errors?.password_confirmation?.type ===
                              "required" && (
                                <label style={{ color: 'red', fontSize: '15px' }} htmlFor="password_confirmation">
                                  Please enter your confirmation password
                                </label>
                              )}
                            {errors?.password_confirmation &&
                              errors?.password_confirmation?.type ===
                              "minLength" && (
                                <label style={{ color: 'red', fontSize: '15px' }} htmlFor="password_confirmation">
                                  Your password should contain at least 6
                                  characters
                                </label>
                              )}
                            {errors?.password_confirmation &&
                              errors?.password_confirmation?.type ===
                              "pattern" && (
                                <label style={{ color: 'red', fontSize: '15px' }} htmlFor="password_confirmation">
                                  Your password should contain at-least 1
                                  Uppercase, 1 Lowercase, 1 Numeric and 1
                                  special character
                                </label>
                              )}
                            {conditionCheck ? <label className="text-left" style={{ color: 'red', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="password_confirmation">
                              New password and confirm password does not match
                            </label> : null}
                          </div>
                        </Col>

                        <Col md={12} sm={12}>
                          <div className="form-group mt-3">
                            <Button
                              title={"Submit"}
                              className={"btn w-100 loginsubmit"}
                              type="submit"
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false); // close popup
          if (redirectToLogin) {
            history("/login");
          }
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

Index.propTypes = {
  superUserParams: PropTypes.object.isRequired,
  setting: PropTypes.shape({
    name: PropTypes.string,
    logo_path: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    getSettingData: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    superUserParams: state.superUserParams,
    setting: state.setting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...userActions,
      ...settingActions
    }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
